import React from "react";
import { QuoteIcon, StarIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { testimonials } from "../../data/content";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-296" data-mp="3mgsh9wmysp55">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-297" data-mp="3r80vr735j0p6" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <section className="bg-cream px-4 py-16 sm:px-6 sm:py-24" aria-labelledby="testimonials-title" data-id="element-298" data-mp="421houdz8cch">
      <div className="mx-auto max-w-3xl text-center" data-id="element-299" data-mp="91mdwx1ri6li">
        <p className="text-sm font-bold uppercase tracking-wide text-brand" data-id="element-300" data-mp="9031jhj88fp0">What dental professionals are saying</p>
        <h2 id="testimonials-title" className="mt-3 font-display text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-301" data-mp="2atiqm9zo1mhv">
          A More Organized Approach to Mandibular Denture Cases
        </h2>
      </div>

      <figure className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-3xl bg-navy-900 text-white md:grid md:grid-cols-[280px_1fr]" data-id="element-302" data-mp="1sl2nzyexly1m">
        <img src={featured.image} alt={featured.name} className="aspect-square w-full object-cover md:h-full md:aspect-auto" data-id="element-303" data-mp="1ns9iv9fjwnp0" />
        <div className="flex flex-col p-6 sm:p-9" data-id="element-304" data-mp="1isdbr1bk4g58">
          <QuoteIcon className="h-9 w-9 text-gold-400" aria-hidden="true" data-id="element-305" data-mp="1eu5u8499rasz" />
          <blockquote className="mt-4 text-lg font-medium leading-relaxed sm:text-xl" data-id="element-306" data-mp="2bjx2d6ahgwh9">“{featured.quote}”</blockquote>
          <figcaption className="mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-white/15 pt-5" data-id="element-307" data-mp="26lde2z8f38lq">
            <div data-id="element-308" data-mp="22h5lus2r3air">
              <p className="font-display text-lg font-extrabold" data-id="element-309" data-mp="22ktii03hsd1p">{featured.name}</p>
              <p className="text-sm text-white/70" data-id="element-310" data-mp="1xj42e61ex96r">
                {featured.role} · {featured.topic}
              </p>
            </div>
            <Stars data-id="element-311" data-mp="m4gtls0h1crw" />
          </figcaption>
        </div>
      </figure>

      <div className="mx-auto mt-5 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-312" data-mp="m35sjzyeuj4h">
        {rest.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm ring-1 ring-navy-900/5" data-id="element-313" data-mp="njjhukr91c4s">
            <div className="flex items-center gap-4" data-id="element-314" data-mp="eky3z2wq2lac">
              <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-cream" loading="lazy" data-id="element-315" data-mp="ek67zqz7qljj" />
              <div className="min-w-0" data-id="element-316" data-mp="ioe0lz8skln1">
                <p className="font-display text-base font-extrabold text-ink" data-id="element-317" data-mp="4uuyi38ezev4">{t.name}</p>
                <p className="text-sm text-muted" data-id="element-318" data-mp="9mczgraftfg3">{t.role}</p>
                <div className="mt-1" data-id="element-319" data-mp="9no6czz6j3bf">
                  <Stars data-id="element-320" data-mp="3r34e57sj047t" />
                </div>
              </div>
            </div>
            <blockquote className="mt-5 text-base leading-relaxed text-ink" data-id="element-321" data-mp="3w1666i7xjdvf">“{t.quote}”</blockquote>
            <p className="mt-auto pt-5 text-xs font-bold uppercase tracking-wide text-brand" data-id="element-322" data-mp="3i1wotf7zmdpv">{t.topic}</p>
          </figure>)}
      </div>

      <p className="mx-auto mt-6 max-w-2xl text-center text-xs text-muted" data-id="element-323" data-mp="3n082y25bfadw">
        Testimonials shown are illustrative examples of professional feedback.
      </p>

      <SectionCta label="Get your complete clinical blueprint" data-id="element-324" data-mp="2ygo7np66dawx" />
    </section>;
}